<template>
  <div class="align p-4">
    <div class="row">
      <div v-if="['redator', 'ex-redator', 'publisher'].includes(user.profile_type)" class="col-12">
        <div class="card">
          <div class="p-4">
            <div id="home_informations">
              <div class="d-flex">
                <div class="item d-flex">
                  <div class="icon me-3">
                    <i class="fa-regular fa-wallet"></i>
                  </div>
                  <div class="informations">
                    <h4>Saldo</h4>
                    <h5>{{ $moneyFormat(informations.current_balance) }}</h5>
                  </div>
                </div>

                <div class="item d-flex">
                  <div class="icon me-3">
                    <i class="fa-regular fa-sack-dollar"></i>
                  </div>
                  <div class="informations">
                    <h4>Total ganho</h4>
                    <h5>{{ $moneyFormat(informations.total_earnings) }}</h5>
                  </div>
                </div>

                <div class="item d-flex">
                  <div class="icon me-3">
                    <i class="fa-regular fa-user"></i>
                  </div>
                  <div class="informations">
                    <h4>Perfil de usuário</h4>
                    <h5>NET+1</h5>
                  </div>
                </div>

                <div v-if="['redator'].includes(user.profile_type)" class="item ms-auto">
                  <router-link :to="{ name: 'articleStepForm' }">
                    <PrimaryButton class="px-5" id="btn_write">
                      Escrever
                    </PrimaryButton>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalDialog v-model="showMegaSorteNumbersModal" title="MegaSorte">
        <router-link :to="{ name: 'megaSorteNumbers' }">
          <img src="../assets/images/banner-megasorte-square.jpg" class="w-100" />
        </router-link>
      </ModalDialog>

      <div v-if="['redator', 'ex-redator'].includes(user.profile_type)" class="col-12 mt-4">
        <div class="card">
          <div class="p-4">
            <h5>Redator</h5>
          </div>
          <div class="p-2 divisor_bottom">
            <HomeChart :data="redatorChartData" color="#00bfcf" />
          </div>
          <div class="row horizontal_informations">
            <div class="col">
              <div class="p-4 item">
                <h6 class="mb-4 d-block">Hoje - Social</h6>
                <div class="row">
                  <div class="col">
                    <small class="d-block">Cliques</small>
                    <strong>{{ $numberFormat(informations.redator.social_visits_today) }}</strong>
                  </div>
                  <div class="col">
                    <small class="d-block">Estimado</small>
                    <strong>{{ $moneyFormat(informations.redator.social_estimated_today) }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="p-4 item">
                <h6 class="mb-4 d-block">Ontem - Social</h6>
                <div class="row">
                  <div class="col">
                    <small class="d-block">Cliques</small>
                    <strong>{{ $numberFormat(informations.redator.social_visits_yesterday) }}</strong>
                  </div>
                  <div class="col">
                    <small class="d-block">Ganhos</small>
                    <strong>{{ $moneyFormat(informations.redator.social_estimated_yesterday) }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="p-4 item">
                <h6 class="mb-4 d-block">Este mês - Social</h6>
                <div class="row">
                  <div class="col">
                    <small class="d-block">Cliques</small>
                    <strong>{{ $numberFormat(informations.redator.social_visits_month) }}</strong>
                  </div>
                  <div class="col">
                    <small class="d-block">Ganhos</small>
                    <strong>{{ $moneyFormat(informations.redator.social_estimated_month) }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="divisor_bottom"></div>

          <div class="row horizontal_informations">
            <div class="col">
              <div class="p-4 item">
                <h6 class="mb-4 d-block">Hoje - Orgânico</h6>
                <div class="row">
                  <div class="col">
                    <small class="d-block">Cliques</small>
                    <strong>{{ $numberFormat(informations.redator.organic_visits_today) }}</strong>
                  </div>
                  <div class="col">
                    <small class="d-block">Estimado</small>
                    <strong>{{ $moneyFormat(informations.redator.organic_estimated_today) }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="p-4 item">
                <h6 class="mb-4 d-block">Ontem - Orgânico</h6>
                <div class="row">
                  <div class="col">
                    <small class="d-block">Cliques</small>
                    <strong>{{ $numberFormat(informations.redator.organic_visits_yesterday) }}</strong>
                  </div>
                  <div class="col">
                    <small class="d-block">Ganhos</small>
                    <strong>{{ $moneyFormat(informations.redator.organic_estimated_yesterday) }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="p-4 item">
                <h6 class="mb-4 d-block">Este mês - Orgânico</h6>
                <div class="row">
                  <div class="col">
                    <small class="d-block">Cliques</small>
                    <strong>{{ $numberFormat(informations.redator.organic_visits_month) }}</strong>
                  </div>
                  <div class="col">
                    <small class="d-block">Ganhos</small>
                    <strong>{{ $moneyFormat(informations.redator.organic_estimated_month) }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="['redator', 'publisher'].includes(user.profile_type)" class="col-12 mt-4 order-2">
        <div class="card">
          <div class="p-4">
            <h5>Publisher</h5>
          </div>
          <div class="p-2 divisor_bottom">
            <HomeChart :data="publisherChartData" color="#583a8e" />
          </div>
          <div class="row horizontal_informations">
            <div class="col">
              <div class="p-4 item">
                <h6 class="mb-4 d-block">Hoje</h6>
                <div class="row">
                  <div class="col">
                    <small class="d-block">Cliques</small>
                    <strong>{{ $numberFormat(informations.publisher.visits_today) }}</strong>
                  </div>
                  <div class="col">
                    <small class="d-block">Estimado</small>
                    <strong>{{ $moneyFormat(informations.publisher.estimated_today) }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="p-4 item">
                <h6 class="mb-4 d-block">Ontem</h6>
                <div class="row">
                  <div class="col">
                    <small class="d-block">Cliques</small>
                    <strong>{{ $numberFormat(informations.publisher.visits_yesterday) }}</strong>
                  </div>
                  <div class="col">
                    <small class="d-block">Ganhos</small>
                    <strong>{{ $moneyFormat(informations.publisher.estimated_yesterday) }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="p-4 item">
                <h6 class="mb-4 d-block">Este mês</h6>
                <div class="row">
                  <div class="col">
                    <small class="d-block">Cliques</small>
                    <strong>{{ $numberFormat(informations.publisher.visits_month) }}</strong>
                  </div>
                  <div class="col">
                    <small class="d-block">Ganhos</small>
                    <strong>{{ $moneyFormat(informations.publisher.estimated_month) }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center mt-4">
      <small style="color: #ccc">v{{ informations.version }}</small>
    </div>

  </div>
</template>
  
<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import HomeChart from '@/components/HomeChart.vue'
import { storeToRefs } from 'pinia';
import {onBeforeMount, ref} from 'vue'
import { inject } from 'vue';
import { useHomeStore } from '@/stores/HomeStore'
import { useAuthStore } from '@/stores/AuthStore';
import ModalDialog from "@/components/ModalDialog.vue";
import { useRouter } from "vue-router";

const loader = inject('$loader');
const router = useRouter();

const authStore = useAuthStore();
const homeStore = useHomeStore();

const { informations } = storeToRefs(homeStore);
const { user } = storeToRefs(authStore);

const publisherChartData = ref([{ name: 'Cliques', data: [] }]);
const redatorChartData = ref([{ name: 'Cliques', data: [] }]);

const showMegaSorteNumbersModal = ref(false);

onBeforeMount(async() => {
  if (user.value.profile_type == 'publipost') {
    router.push({name: 'publiposts'});
  }

  loader.show();
  let currentVersion = informations.value.version;

  createChart();

  await homeStore.getInformations();

  if(informations.value.version !== currentVersion && currentVersion !== null){
    location.reload();
  }

  loader.hide();
  createChart();
});

function createChart(){
  publisherChartData.value = [{ name: 'Cliques', data: informations.value.publisher.chart.visits }];
  redatorChartData.value = [{ name: 'Cliques', data: informations.value.redator.chart.visits }];
}

</script>

  
<style scoped>
#home_informations .icon {
  background-color: #00bfcf;
  display: inline-block;
  width: 40px;
  height: 40px;
  padding: 9px 10px;
  border-radius: 25px;
  font-size: 16px;
  color: #fff;
}

#home_informations h4 {
  font-size: 15px;
  margin-bottom: 2px;
}

#home_informations h5 {
  font-size: 15px;
  font-weight: 600;
  color: #00bfcf;
  margin-bottom: 0;
}

#home_informations .item {
  margin-right: 60px;
}

#home_informations .item:last-child {
  margin-right: 0;
}

.divisor_bottom {
  border-bottom: 1px #d7d7d7 solid;
}

.horizontal_informations > .col {
  border-right: 1px #d7d7d7 solid;
}

.horizontal_informations .col:last-child {
  border-right: 0;
}

.horizontal_informations small {
  color: #505050;
}

.horizontal_informations .badge {
  background-color: #e0e0e0;
  color: #505050;
}

@media screen and (max-width: 768px){
  .horizontal_informations .p-4 .row {
    display: block;
  }

  .horizontal_informations .p-4 .row .col {
    margin-top: 5px
  }

  #btn_write {
    width: 100%;
    display: block;
  }
}

@media screen and (max-width: 500px){
  .horizontal_informations {
    display: block;
  }
}
</style>